"use client";

import { InfoBox, Link, Typography } from "@cappelendamm/design-system/react";
import { WarningCircle } from "iconoir-react";
import { getIsTeacherFromSessionClaims } from "@/utils/getIsTeacherFromSessionClaims";
import { useAuth } from "@clerk/nextjs";

export const RestrictedProductInfoBox = () => {
  const { sessionClaims, isLoaded } = useAuth();

  if (!isLoaded) return null;

  const isTeacher = getIsTeacherFromSessionClaims(sessionClaims);

  // Only show the info box if the user is not a teacher
  if (isTeacher) return null;

  return (
    <InfoBox className="flex w-full items-start gap-2">
      <WarningCircle width={32} height={32} className="text-lg" />
      <Typography variant="body-sm">
        Dette produktet er forbeholdt lærere. Logg inn for å bestille. <br />{" "}
        Har du ikke lærertilgang?{" "}
        <Link
          variant="inline"
          href="mailto:kundeservice@cappelendamm.no"
          className="text-black"
        >
          Kontakt oss for hjelp.
        </Link>
      </Typography>
    </InfoBox>
  );
};
